import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ListModule',
  components: {
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState({
      active: state => state.sclListModule.active,
      values: state => state.sclListModule.values,
      isModify: state => state.sclListModule.isModify
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    layoutSizeList () {
      return Constants.Layout.ButtonSize
    },

    // input
    posX: {
      get () {
        return this.values.posX
      },
      set (value) {
        this.setInputValue({
          keys: ['posX'],
          value: value
        })
      }
    },
    posY: {
      get () {
        return this.values.posY
      },
      set (value) {
        this.setInputValue({
          keys: ['posY'],
          value: value
        })
      }
    },
    layoutSizeType: {
      get () {
        return this.values.layoutSizeType
      },
      set (value) {
        this.setInputValue({
          keys: ['layoutSizeType'],
          value: value
        })
      }
    },

    // validate
    disablePostButton () {
      if (this.filterMode === 0) return false
        return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      hide: 'sclListModule/hide',
      reset: 'sclListModule/reset',
      setLayer: 'screenConfigLayout/setLayer',
      removeLayer: 'screenConfigLayout/removeLayer'
    }),
    ...mapMutations({
      setInputValue: 'sclListModule/setInputValue'
    }),

    init () {
      // this.loading = true
    },

    /**
     * レイヤー情報を設定
     */
    postData () {
      this.setLayer(this.values)
      this.hide()
    },
    /**
     * レイヤー情報を削除
     */
    removeData () {
      this.removeLayer(this.values)
      this.hide()
    },

    /**
     * テキストエリアでEnterキー押下の処理
     */
    onKeydownEnter(keyCode) {
      if (keyCode !== 13) return
      this.postData()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}